import { Component, EventEmitter, inject, Input, OnChanges, Output } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  BaseIdDirective,
  ChildIdDirective,
  CoreUiModule,
  getLoadedValueOrNull,
  trackLoadingSwitchMap,
} from 'webcommon/core-ui';
import {
  generateHtmlId,
  GenericSimpleChanges,
  PRM_SessionResponse,
  ServerFeature,
  SessionRequest_Create
} from 'webcommon/shared';
import { TerminologyRepository } from 'webcommon/webapi';
import { ServerInfoRepository } from 'webcommon/legacy-common';

const nextId = generateHtmlId('ap-terminology-search');

@Component({
  selector: 'ap-terminology-search',
  standalone: true,
  imports: [CoreUiModule, ChildIdDirective],
  templateUrl: './terminology-search.component.html',
  styleUrls: ['./terminology-search.component.less'],
  host: {
    /* eslint-disable quote-props */
    'class': 'flex-col',
  },
  hostDirectives: [
    BaseIdDirective,
  ],
})
export class TerminologySearchComponent implements OnChanges {
  private terminologyRepository = inject(TerminologyRepository);

  @Input() sessionRequest: SessionRequest_Create;
  @Output() sessionResponseChange = new EventEmitter<PRM_SessionResponse | undefined>();

  createSession$ = new ReplaySubject<SessionRequest_Create>(1);
  sessionResponse$ = this.createSession$.pipe(
    trackLoadingSwitchMap((sessionRequest) => {
      return this.terminologyRepository.createSession(sessionRequest);
    }),
    tap((value) => {
      const sessionResponse = getLoadedValueOrNull(value)?.value;
      this.sessionResponseChange.emit(sessionResponse);
    }),
  );

  static isSupportedFn(): () => boolean {
    const serverInfoRepository = inject(ServerInfoRepository);
    return () => {
      return serverInfoRepository.isSupported(
        ServerFeature.Terminology_Sessions,
        ServerFeature.Terminology_IMOSearch,
      );
    };
  }

  constructor(
  ) {
    BaseIdDirective.setupAsHostDirective(nextId);
  }

  ngOnChanges(changes: GenericSimpleChanges<TerminologySearchComponent>) {
    if (changes.sessionRequest?.currentValue) {
      this.createSession$.next(changes.sessionRequest.currentValue);
    }
  }
}
